<template src="./SimpleCaseSolution.html"></template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Case } from "@/models/cases/Case";
import BaseButton from "@/components/BaseButton";
import { solutionModule } from "@/store/modules/solution";
import { SolutionGetters } from "@/store/modules/solution/getters";
import { VForm } from "vuetify/lib/components/VForm/VForm";

export default defineComponent({
    components: { BaseButton },
    props: { caseModel: { type: Object as PropType<Case>, required: true } },
    emits: ["solve"],
    computed: {
        ...solutionModule.mapGetters({ loading: SolutionGetters.Loading })
    },
    methods: {
        async submit(): Promise<void> {
            const result = await (this.$refs.form as VForm).validate();
            if (result.valid) this.$emit("solve", this.solution);
        }
    },
    data() {
        return { solution: "" as string };
    }
});
</script>
